import React from 'react';
import "./WaitlistManagementBtnContainer.sass";
import VCButton from './VCButton/VCButton';
// @ts-ignore
import { LocalizationContext } from "react-localize";
import { ReservationType } from 'Interfaces/GetReservations';
import { WaitlistManagementType } from 'Interfaces/WaitlistManagementInterfaces';
type Props = {
    setActive: any
    activeBtn: string
}

class WaitlistManagementBtnContainer extends React.Component<Props>{
    constructor(props: Props) {
        super(props);
        this.state = {
            activeBtn: props.activeBtn
        }
    }
   
    render(){
        const { localize } = this.context;
        const btnContents =[
            {
                copy: localize("Active Waitlist"),
                route:"",
                key: WaitlistManagementType.Active
                
            },
            /* Commenting out this code for Waitlist MVP */
            // {
            //     copy:localize("static.content.waitlist-management-inactive-waitlist"),
            //     route:"",
            //     key: WaitlistManagementType.InActive
            // }
        ]

        return(
            <div className="btn-wrp">
                {
                    btnContents.map((contents) =>{
                        return <VCButton key={contents.key} contents={contents} setActive={this.props.setActive} active={this.props.activeBtn} btnCls={"active-waitlist"}/>
                    })
                }               
            </div>
        )
    }    
}
WaitlistManagementBtnContainer.contextType = LocalizationContext;
export default WaitlistManagementBtnContainer;